
// import 'lazysizes';
import imagesLoaded from 'imagesloaded';
import Flickity from 'flickity';
import InfiniteScroll from 'infinite-scroll';
import Packery from 'packery';
import 'flickity-fade';
import Cookies from 'js-cookie';
import cookieconsent from 'cookieconsent';
import './plugins/jquery.fitvids';

import './modules/modal';
// import './modules/tablist';

const stateMode = 'cookie';

$(() => {

  window.cookieconsent.initialise({
    type: 'info',
    regionalLaw: true,
    law: {
      countryCode: "UK",
    },
    cookie: {
      name: 'fod-cookie-consent',
      path: '/',
      // domain: 'localhost',
      expiryDays: 365,
      secure: false
    },
    dismissOnTimeout: 5000,
    content: {
      dismiss: 'Close',
      link: 'Learn more',
      href: '/cookie-policy',
      policy: 'Cookie Policy'
    }
  });

  const pageLoad = () => {

    // Carousels

    document.querySelectorAll('.hero-slider').forEach((item) => {

        let settings = {
          pageDots: true,
          fade: true,
          autoPlay: true,
          prevNextButtons: false,
          pauseAutoPlayOnHover: false
        };

        // add fade mode
        if( "settings" in item.dataset ){
            settings = JSON.parse( item.dataset.settings );
        }

        const carousel = new Flickity( item, settings );

    });


    // Sliders

    document.querySelectorAll('.slider').forEach((item) => {

      let settings = {
        pageDots: true,
        cellSelector: '.slider-item',
        groupCells: true,
        prevNextButtons: true
      };

      // add fade mode
      if( "settings" in item.dataset ){
          settings = JSON.parse( item.dataset.settings );
      }

      imagesLoaded( item, function( instance ) {
        // console.log('all images are loaded');
        const slider = new Flickity( item, settings );
      });

    });

    // masonry grids

    document.querySelectorAll('.masonry-grid').forEach((item) => {

      const pckry = new Packery( item, {
        // options
        itemSelector: '.masonry-item',
        percentPosition: true
      });

      // imagesLoaded( item, function( instance ) {
      //   const slider = new Flickity( item, settings );
      // });

    });

    // InfiniteScroll

    if(  document.querySelector('.pagination-button') ){
      const blogroll = document.querySelector('.blogroll');
      const infScroll = new InfiniteScroll( blogroll, {
        // options
        path: '.pagination-button',
        append: '.tease',
        history: false,
        button: '.pagination-button',
        scrollThreshold: false,
      });
    }


    $('.video-player').fitVids();

    // Category drop downs

    $('.cat-drop').on('click', function(){
      $(this).parent().toggleClass('active');
      return false;
    });

    $('.category-filter').on('mouseleave', function(){
      $(this).removeClass('active');
      return false;
    });

    // Search modal

    $('#searchtoggle').on('click', function(){
      $('body').addClass('modal-search-open');
      document.querySelector('#searchinput2').focus();
    });

    $('#search .close').on('click',function(){
      $('body').removeClass('modal-search-open');
    });

    // Accessibility modal    

    // High Contrast mode
    $(".a11y-contrast button").on('click', function () {
      const contrast = $(this).data("hc-mode");
      // console.log(contrast);

      if (contrast == "highcontrast") {
        $('html').addClass('a11y-hc');
        Cookies.set('fod-contrast', contrast, { expires: 7 });
        // localStorage.setItem("fod-contrast", contrast);
      } else {
        $('html').removeClass('a11y-hc');
        Cookies.remove('fod-contrast');
        // localStorage.removeItem("fod-contrast");
      }

    });

    // Font size
    $(".a11y-fontsize button").on('click', function () {
      const fontsize = $(this).data("fs");
      console.log(fontsize);

      $('html').removeClass('a11y-fs-med');
      $('html').removeClass('a11y-fs-lrg');

      if (fontsize !== "sml") {
        // localStorage.setItem("fod-fontsize", fontsize);
        Cookies.set('fod-fontsize', fontsize, { expires: 7 });
      }else{
        Cookies.remove('fod-fontsize');
        // localStorage.removeItem("fod-fontsize");
      }

      switch(fontsize){
        case "med":
          $('html').addClass('a11y-fs-med');
        break;
        case "lrg":
          $('html').addClass('a11y-fs-lrg');
        break;
        default:
          console.log('remove any font stuff');
        break;
      }

    });

    // Check a11y settings from localStorage

    // window.onload = function () {
    //   const contrast = localStorage.getItem("fod-contrast");
    //   const fontsize = localStorage.getItem("fod-fontsize");

    //   if (contrast != undefined || contrast != null) {
    //     if (contrast == "highcontrast") {
    //       $('html').addClass('a11y-hc');
    //     }
    //   }

    //   if (fontsize != undefined || fontsize != null) {
    //     $('html').addClass('a11y-fs-'+fontsize);
    //   }

    // }

    $('#a11ytoggle').on('click', function(){
      $('body').addClass('modal-a11y-open');
    });

    $('#a11y .close').on('click',function(){
      $('body').removeClass('modal-a11y-open');
    });

    // mobile menu

    $('.navbar-burger').on("click", function(){
      $('body').addClass('mobile-menu-open');
    });

    $('.mobile-menu .navbar-close').on("click", function(){
      $('body').removeClass('mobile-menu-open');
    });

    $('.mobile-navbar-drop-toggle').on("click", function(){
      $(this).attr("aria-expanded", function (i, attr) {
        return attr == "true" ? "false" : "true";
      });
      return false;
    });

    // alert box

    

    $('.alert .close').on("click", function(){
      $('.alert').remove();
      Cookies.set('fod-alertbox-hide', true, { expires: 2 });
    });

  } // end pageLoad()

  pageLoad();

});
